import { render, staticRenderFns } from "./RbuPeriodInput.vue?vue&type=template&id=657849cc"
import script from "./RbuPeriodInput.vue?vue&type=script&lang=js"
export * from "./RbuPeriodInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports